import {Popover} from 'bootstrap';
import Tooltip from 'bootstrap/js/dist/tooltip';
import $ from 'jquery';
window.$ = window.jQuery = $;
require('select2');
import 'slick-carousel'
import '@popperjs/core/lib/popper.js';
import AOS from 'aos';
import Player from '@vimeo/player';
import React from 'react';
import ReactDOM from 'react-dom';
import Programs from './Programs';
import News from './News';
import Events from './Events';

jQuery( document ).ready( ( $ ) => {
	const NorthlandScripts = {
		init() {
			this._initJs();
			this._formValidation();
			this._initMenu();
			this._initSearch();
			this._initAnimations();
			this._initHeroVideo();
			this._initPrograms();
			this._initNews();
			this._initEvents();
			this._initNewsCarousel();
			this._initProgressBar();
			this._initFloatLinks();
			this._initCollapseMobile();
			this._initFormControls();
			this._initPrint();
			this._initPopovers();
			this._initClickableRow();
			this._initCompare();
			this._initClassSchedules();
		},
		_initJs() {
			$( document.documentElement )
				.removeClass( 'no-js' )
				.addClass( 'js' );

			const tooltipTriggerList = [].slice.call(
				document.querySelectorAll( '[data-bs-toggle="tooltip"]' )
			);
			const tooltipList = tooltipTriggerList.map(
				( tooltipTriggerEl ) => {
					return new Tooltip( tooltipTriggerEl );
				}
			);
		},
		_formValidation() {
			$('.course-descriptions select').change(function(e) {
				if( $(e.currentTarget).val() ) {
					$('.course-descriptions').submit();
				}
			});
		},
		_initMenu() {
			// Local menu

			const closeLocalMenu = () => {
				$( '.hero-component-overlay' ).removeClass( 'local-nav--open' );
				$( '.local-nav.navbar' ).slideUp( 200 );
				$( '.local-nav--mobile' ).removeClass( 'expanded' );
				$( '.local-nav--mobile' ).attr( 'aria-expanded', 'false' );
				$( '.local-nav--mobile' ).focus();
			};

			$( '.local-nav--mobile' ).click( ( e ) => {
				if ( $( '.local-nav.navbar' ).is( ':hidden' ) ) {
					$( '.hero-component-overlay' ).addClass( 'local-nav--open' );
					$( '.local-nav.navbar' ).slideDown( 200 );
					$( '.local-nav.navbar .nav-item:first-child a').focus();
					$( '.local-nav--mobile' ).addClass( 'expanded' );
					$( '.local-nav--mobile' ).attr( 'aria-expanded', 'true' );
				} else if ( $( '.local-nav.navbar' ).is( ':visible' ) ) {
					closeLocalMenu();
				}
			} );

			$( '.local-nav.navbar .nav-item a' ).keydown( (e) => {
				if (e.key === 'ArrowDown') {
					$(e.currentTarget).parent().next().find('a').focus();
					e.preventDefault();
				} else if (e.key === 'ArrowUp') {
					$(e.currentTarget).parent().prev().find('a').focus();
					e.preventDefault();
				}
			} );

			$( '.local-nav.navbar .nav-item:first-child a' ).keydown( (e) => {
				if (e.key === 'ArrowUp') {
					$( '.local-nav.navbar .nav-item:last-child a').focus();
					e.preventDefault();
				}
			} );

			$( '.local-nav.navbar .nav-item:last-child a' ).keydown( (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					if( $('.local-nav--mobile.expanded').length > 0 ) {
						// Only if mobile menu is open.
						closeLocalMenu();
						e.preventDefault();
					}
				} else if (e.key === 'ArrowDown') {
					$( '.local-nav.navbar .nav-item:first-child a').focus();
					e.preventDefault();
				}
			} );

			$( '.local-nav--mobile, .local-nav.navbar a' ).keydown( (e) => {
				if( $('.local-nav--mobile.expanded').length > 0 ) {
					// Only if mobile menu is open.
					if (e.key === 'Esc' || e.key === 'Escape') {
						closeLocalMenu();
					}
				}
			} );

			// Skip to navigation link
			$('.skip-nav').click( (e) => {
				$( '.main-menu' ).removeClass( 'main-menu--hidden' );
				$( '.mobile-nav-button' ).attr('aria-expanded', 'true');
				$( '.menu-overlay' ).addClass( 'menu-overlay--visible' );
				$( 'body' ).addClass( 'fixed-body' );
				setTimeout(() => {
					$( '.main-menu button,.main-menu a' ).first().focus();
				}, 200);
				e.preventDefault();
			});

			// Close main menu on click
			$( document ).click( ( e ) => {
				if ( $( '.header .mobile-nav-button' )[ 0 ] === e.target || $( '.nav-float .mobile-nav-button' )[ 0 ] === e.target || $( '.skip-nav' )[ 0 ] === e.target ) {
					return true;
				}

				if ( ! $( '.main-menu' ).hasClass( 'main-menu--hidden' ) ) {
					if ( ! e.target.closest( '.main-menu' ) && ! e.target.closest( '.nav-float' ) && ! e.target.closest('.mobile-nav-button') ) {
						console.log('close');
						closeMenu();
					}
				}
			} );

			let hierarchy = [];

			const closeMenu = () => {
				$( '.main-menu' ).addClass( 'main-menu--hidden' );
				hierarchy = [];
				setTimeout( () => {
					$( '.main-menu .back' ).hide();
					$( '.submenu' ).addClass( 'submenu--hidden' );
					$( '.subsubmenu' ).addClass( 'subsubmenu--hidden' );
					$( '.submenu a.active' ).removeClass( 'active' );
					$( '.subsubmenu-wrapper' ).hide();
					$( '.menu-wrapper' ).show();
					$( '.menu-overlay' ).removeClass( 'menu-overlay--visible' );
					$( 'body' ).removeClass( 'fixed-body' );
					$( '.mobile-nav-button' ).focus();
					$( '.mobile-nav-button' ).attr('aria-expanded', 'false');
					$( '.main-menu a[aria-expanded="true"], .submenu a[aria-expanded="true"], .subsubmenu a[aria-expanded="true"]' ).attr('aria-expanded', 'false');
					$( '.submenu[aria-hidden="false"], .subsubmenu[aria-hidden="false"' ).attr('aria-hidden', 'true');
				}, 200 );
			};

			// Open main menu
			$( 'body' ).on( 'click', '.mobile-nav-button', () => {
				if ( $( '.main-menu' ).hasClass( 'main-menu--hidden' ) ) {
					$( '.main-menu' ).removeClass( 'main-menu--hidden' );
					$( '.mobile-nav-button' ).attr('aria-expanded', 'true');
					$( '.menu-overlay' ).addClass( 'menu-overlay--visible' );
					$( 'body' ).addClass( 'fixed-body' );
					setTimeout(() => {
						$( '.main-menu button,.main-menu a' ).first().focus();
					}, 200);
				} else {
					closeMenu();
				}
			} );

			$( '.primary-menu-wrapper .close' ).keydown( (e) => {
				if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
					closeMenu();
					e.preventDefault();
				} else if(e.key === 'ArrowDown' || e.key === 'ArrowRight') {
					$('.primary-menu-wrapper .logo').focus();
					e.preventDefault();
				}
			} );

			$( '.primary-menu-wrapper .logo' ).keydown( (e) => {
				if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
					$('.primary-menu-wrapper .close').focus();
					e.preventDefault();
				} else if(e.key === 'ArrowDown') {
					$('.menu-wrapper .menu-1 li:first-child a').focus();
					e.preventDefault();
				}
			} );


			$( '.menu-wrapper .menu li:first-child a' ).keydown( (e) => {
				if (e.key === 'ArrowUp') {
					$( '.menu-wrapper .menu:last-child li:last-child a' ).focus();
					e.preventDefault();
				}
			} );

			$( '.menu-wrapper .menu-3 li:last-child a' ).keydown( (e) => {
				if (e.key === 'ArrowDown') {
					$( '.menu-wrapper .menu:first-child li:first-child a' ).focus();
					e.preventDefault();
				}
			} );

			$( 'body' ).on('keydown', '.submenu:visible .menu-2 li:first-child a', (e) => {
				if (e.key === 'ArrowUp') {
					$( '.submenu:visible .menu-3 li:last-child a' ).focus();
					e.preventDefault();
				}
			} );

			$( 'body' ).on('keydown', '.submenu:visible .menu-3 li:last-child a', (e) => {
				if (e.key === 'ArrowDown') {
					$( '.submenu:visible .menu-2 li:first-child a' ).focus();
					e.preventDefault();
				}
			} );

			$( 'body' ).on('keydown', '.subsubmenu:visible .menu-2 li:first-child a', (e) => {
				if (e.key === 'ArrowUp') {
					$( '.subsubmenu:visible .menu-3 li:last-child a' ).focus();
					e.preventDefault();
				}
			} );

			$( 'body' ).on('keydown', '.subsubmenu:visible .menu-3 li:last-child a', (e) => {
				if (e.key === 'ArrowDown') {
					$( '.subsubmenu:visible .menu-2 li:first-child a' ).focus();
					e.preventDefault();
				}
			} );

			$( '.menu-wrapper a' ).keydown( (e) => {
				if (e.key === 'ArrowDown') {
					let path = $(e.currentTarget).parent().next().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').nextAll('.menu').find('a').first();
					}
					path.focus();
					e.preventDefault();
				} else if (e.key === 'ArrowUp') {
					let path = $(e.currentTarget).parent().prev().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').prevAll('.menu').find('a').last();
					}
					path.focus();
					e.preventDefault();
				}
			} );

			$( '.submenu-wrapper a' ).keydown( (e) => {
				if (e.key === 'ArrowDown') {
					let path = $(e.currentTarget).parent().next().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').nextAll('.menu').find('a').first();
					}
					path.focus();
					e.preventDefault();
				} else if (e.key === 'ArrowUp') {
					let path = $(e.currentTarget).parent().prev().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').prevAll('.menu').find('a').last();
					}
					path.focus();
					e.preventDefault();
				}
			} );

			$( '.subsubmenu-wrapper a' ).keydown( (e) => {
				if (e.key === 'ArrowDown') {
					let path = $(e.currentTarget).parent().next().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').nextAll('.menu').find('a').first();
					}
					path.focus();
					e.preventDefault();
				} else if (e.key === 'ArrowUp') {
					let path = $(e.currentTarget).parent().prev().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').prevAll('.menu').find('a').last();
					}
					path.focus();
					e.preventDefault();
				}
			} );


			// Close main menu options
			$( '.main-menu .close' ).click( () => {
				closeMenu();
			} );

			$( '.main-menu a, .main-menu button' ).keydown( (e) => {
				if (e.key === 'Esc' || e.key === 'Escape') {
					if( $( '.submenu:visible' ).length > 0 || $( '.subsubmenu:visible' ).length > 0 ) {
						backOne();
					} else {
						closeMenu();
					}
				}
			} );

			const backOne = () => {
				const newItem = hierarchy.pop();
				if ( newItem ) {
					if ( newItem.includes( 'subsubmenu' ) ) {
						// Tier 3
						$( '.main-menu a.active' ).removeClass( 'active' );
						$( '.subsubmenu-wrapper .subsubmenu' ).addClass(
							'subsubmenu--hidden'
						);
						$( '.subsubmenu-wrapper .subsubmenu' ).attr('aria-hidden', 'true');
						$( '.subsubmenu-wrapper' ).hide();
						if ( $( newItem ).length > 0 ) {
							// $( newItem ).removeClass( 'subsubmenu--hidden' );
							$( newItem ).attr( 'aria-hidden', 'true' );
							$( '.submenu-wrapper a[href="' + newItem + '"]').attr('aria-expanded', 'false');
							$( '.submenu-wrapper a[href="' + newItem + '"]').focus();
						}
					} else {
						// Tier 2
						$( '.submenu a.active' ).removeClass( 'active' );
						$( '.submenu:visible' ).addClass( 'submenu--hidden' );
						$( '.submenu-wrapper .submenu' ).attr('aria-hidden', 'true');
						$( '.subsubmenu:visible' ).addClass( 'subsubmenu--hidden' );
						$( '.subsubmenu-wrapper .subsubmenu' ).attr('aria-hidden', 'true');
						$( '.subsubmenu-wrapper' ).fadeOut( 200 );
						$( newItem ).addClass( 'submenu--hidden' );
						$( newItem ).attr( 'aria-hidden', 'true' );

						setTimeout( () => {
							$( '.menu-wrapper' ).fadeIn( 200, function() {
								$( '.menu-wrapper a[href="' + newItem + '"]').attr('aria-expanded', 'false');
								$( '.menu-wrapper a[href="' + newItem + '"]').focus();
							} );
							$( '.main-menu .back' ).fadeOut( 200 );
						}, 200 );
					}
				} else {
					$( '.submenu a.active' ).removeClass( 'active' );
					$( '.submenu:visible' ).addClass( 'submenu--hidden' );
					$( '.submenu-wrapper .submenu' ).attr('aria-hidden', 'true');
					$( '.subsubmenu:visible' ).addClass( 'subsubmenu--hidden' );
					$( '.subsubmenu-wrapper .subsubmenu' ).attr('aria-hidden', 'true');
					$( '.subsubmenu-wrapper' ).fadeOut( 200 );

					setTimeout( () => {
						$( '.menu-wrapper' ).fadeIn( 200 );
						$( '.main-menu .back' ).fadeOut( 200 );
					}, 200 );
				}
			}

			// Go back option
			$( '.main-menu .back' ).click( () => {
				backOne();
			} );

			// Open level 2 menu
			$( 'a[href^="#submenu"]' ).click( ( e ) => {
				$( '.submenu' ).addClass( 'submenu--hidden' );
				$( '.submenu-wrapper .submenu' ).attr('aria-hidden', 'true');
				$( '.menu-wrapper' ).fadeOut( 200, () => {
					const submenu = $( e.currentTarget ).attr( 'href' );
					$( e.currentTarget ).attr('aria-expanded', 'true');
					hierarchy.push( submenu );
					$( submenu ).attr('aria-hidden', 'false');
					$( submenu ).removeClass( 'submenu--hidden' );
					$( submenu ).find('a').first().focus();
					$( '.main-menu .back' ).fadeIn( 200 );
				} );
				e.preventDefault();
			} );

			$( 'a[href^="#submenu"]' ).keydown( (e) => {
				if (e.key === 'ArrowRight') {
					$( '.submenu' ).addClass( 'submenu--hidden' );
					$( '.submenu-wrapper .submenu' ).attr('aria-hidden', 'true');
					$( '.menu-wrapper' ).fadeOut( 200, () => {
						const submenu = $( e.currentTarget ).attr( 'href' );
						$( e.currentTarget ).attr('aria-expanded', 'true');
						hierarchy.push( submenu );
						$( submenu ).attr('aria-hidden', 'false');
						$( submenu ).removeClass( 'submenu--hidden' );
						$( submenu ).find('a').first().focus();
						$( '.main-menu .back' ).fadeIn( 200 );
					} );
					e.preventDefault();
				} else if(e.key === 'ArrowLeft') {
					closeMenu();
				}
			} );

			// Open level 3 menu
			$( 'a[href^="#subsubmenu"]' ).click( ( e ) => {
				$( '.main-menu a.active' ).removeClass( 'active' );
				$( '.subsubmenu-wrapper .subsubmenu' ).addClass(
					'subsubmenu--hidden'
				);
				$( '.subsubmenu-wrapper .subsubmenu' ).attr('aria-hidden', 'true');
				const subsubmenu = $( e.currentTarget ).attr( 'href' );
				$( e.currentTarget ).attr('aria-expanded', 'true');
				hierarchy.push( subsubmenu );
				$( e.currentTarget ).addClass( 'active' );
				if ( $( '.subsubmenu-wrapper' ).is( ':hidden' ) ) {
					$( '.subsubmenu-wrapper' ).fadeIn( 200 );
				}
				if ( $( subsubmenu ).length > 0 ) {
					$( subsubmenu ).removeClass( 'subsubmenu--hidden' );
					$( subsubmenu ).attr('aria-hidden', 'false');
					$( subsubmenu ).find('a').first().focus();
				}

				e.preventDefault();
			} );

			$( 'a[href^="#subsubmenu"]' ).keydown( (e) => {
				if (e.key === 'ArrowRight') {
					$( '.main-menu a.active' ).removeClass( 'active' );
					$( '.subsubmenu-wrapper .subsubmenu' ).addClass(
						'subsubmenu--hidden'
					);
					$( '.subsubmenu-wrapper .subsubmenu' ).attr('aria-hidden', 'true');
					const subsubmenu = $( e.currentTarget ).attr( 'href' );
					$( e.currentTarget ).attr('aria-expanded', 'true');
					hierarchy.push( subsubmenu );
					$( e.currentTarget ).addClass( 'active' );
					if ( $( '.subsubmenu-wrapper' ).is( ':hidden' ) ) {
						$( '.subsubmenu-wrapper' ).fadeIn( 200 );
					}
					if ( $( subsubmenu ).length > 0 ) {
						$( subsubmenu ).removeClass( 'subsubmenu--hidden' );
						$( subsubmenu ).attr('aria-hidden', 'false');
						$( subsubmenu ).find('a').first().focus();
					}

					e.preventDefault();
				}
			} );

			$( 'body' ).on( 'keydown', '.submenu-wrapper .submenu:visible a', (e) => {
				if (e.key === 'ArrowLeft') {
					backOne();
					e.preventDefault();
				}
			} );

			$( 'body' ).on( 'keydown', '.subsubmenu-wrapper .subsubmenu:visible a', (e) => {
				if (e.key === 'ArrowLeft') {
					backOne();
					e.preventDefault();
				}
			} );

			$( '.menu-wrapper .menu:last-child li:last-child a' ).keydown( (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					closeMenu();
					e.preventDefault();
				}
			} );

			$( 'body' ).on('keydown', '.submenu:visible .menu:last-child li:last-child a', (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					backOne();
					e.preventDefault();
				}
			} );
		},
		_initSearch() {
			$( 'body' ).on( 'click', '.header .search.not-active', ( e ) => {
				$( '.search-overlay' ).fadeIn( 200, () => {
					$( '.search-overlay' ).addClass( 'active' );
					$( '.search-overlay' ).attr('aria-hidden', 'false');
					$( '#search-field' ).focus();
					$( e.currentTarget ).addClass( 'active' );
					$( e.currentTarget ).attr('aria-expanded', 'true');
					$( e.currentTarget ).removeClass( 'not-active' );
					$( e.currentTarget ).attr( 'title', 'Close search' );
					$( 'body' ).addClass( 'fixed-body' );
				} );
			} );

			$( '.search-content a, .search-overlay.active button, .utility-nav .search.active, #search-field' ).keydown( (e) => {
				console.log("HI");
				if (e.key === 'Esc' || e.key === 'Escape') {
					$( '.search-overlay' ).fadeOut( 200, () => {
						$( '.search-overlay' ).removeClass( 'active' );
						$( '.search-overlay' ).attr('aria-hidden', 'false');
						$( '.header .search' ).removeClass( 'active' );
						$( '.header .search' ).attr('aria-expanded', 'true');
						$( '.header .search' ).addClass( 'not-active' );
						$( '.header .search' ).attr( 'title', 'Search site' );
						$( '.header .search' ).focus();
						$( 'body' ).removeClass( 'fixed-body' );
					} );
				}
			} );

			$( '#search-field' ).keydown( (e) => {
				if (e.key === 'Tab' && e.shiftKey) {
					$('.header .search').focus();
					e.preventDefault();
				}
			} );

			$( '.header .search.active' ).keydown( (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					$('#search-field').focus();
					e.preventDefault();
				}
			} );

			$( 'body' ).on('keydown', '.search-links li:last-child a', (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					$( '.search-overlay' ).fadeOut( 200, () => {
						$( '.search-overlay' ).removeClass( 'active' );
						$( '.search-overlay' ).attr('aria-hidden', 'false');
						$( '.header .search' ).removeClass( 'active' );
						$( '.header .search' ).attr('aria-expanded', 'true');
						$( '.header .search' ).addClass( 'not-active' );
						$( '.header .search' ).attr( 'title', 'Search site' );
						$( 'body' ).removeClass( 'fixed-body' );
						// setTimeout(() => {
						$( '.header .search' ).first().focus();
						// }, 400);
					} );
					e.preventDefault();
				}
			} );

			$( '.search-results .results-sort' ).change( function() {
				const sort = $(this).val();

				const url = new URL(location.href);
				url.searchParams.set('sort', sort);
				window.location = url;
			});

			$( 'body' ).on( 'click', '.header .search.active', ( e ) => {
				if ( $( '.search-overlay' ).is( ':visible' ) ) {
					$( '.search-overlay' ).fadeOut( 200, () => {
						$( '.search-overlay' ).removeClass( 'active' );
						$( '.search-overlay' ).attr('aria-hidden', 'true');
						$( '.header .search' ).removeClass( 'active' );
						$( '.header .search' ).attr('aria-expanded', 'false');
						$( '.header .search' ).addClass( 'not-active' );
						$( '.header .search' ).attr( 'title', 'Search site' );
						$( 'body' ).removeClass( 'fixed-body' );
					} );
				}
			} );

			$( '.header .search.active, button.search-close' ).click( ( e ) => {
				$( '.search-overlay' ).fadeOut( 200 );
				$( '.search-overlay' ).removeClass( 'active' );
				$( '.search-overlay' ).attr('aria-hidden', 'true');
				$( '.header .search' ).removeClass( 'active' );
				$( '.header .search' ).attr('aria-expanded', 'false');
				$( '.header .search' ).addClass( 'not-active' );
				$( '.header .search' ).attr( 'title', 'Search site' );
				$( 'body' ).removeClass( 'fixed-body' );
			} );
		},
		_initAnimations() {
			$( '.component--intro .message' ).each( ( index, element ) => {
				$( element ).attr( 'data-aos', 'fade-up' );
			} );

			$( '.component--text-image img' ).each( ( index, element ) => {
				$( element ).attr( 'data-aos', 'fade-up' );
			} );

			$(
				'.component--accordion .container, .component--resource .container, .component--image .container, .component--video .container, .component--callout .container, .component--text-pair .container, .component--text .container, .component--column .container, .component--hero .container'
			).each( ( index, element ) => {
				$( element ).attr( 'data-aos', 'fade-in' );
			} );

			AOS.init( {
				delay: 0, // values from 0 to 3000, with step 50ms
				duration: 400, // values from 0 to 3000, with step 50ms
				easing: 'ease', // default easing for AOS animations
				once: true, // whether animation should happen only once - while scrolling down
			} );
		},
		_initHeroVideo() {
			$( '.component--hero-video' ).each( function () {
				const heroThis = this;
				const iframe = $( heroThis ).find( 'iframe' );
				const player = new Player( iframe[ 0 ] );

				$( heroThis )
					.find( '.play-pause' )
					.click( function () {
						if ( 'false' === $( this ).attr( 'aria-pressed' ) ) {
							player.pause();
							$( this ).addClass( 'paused' );
							$( this ).attr( 'aria-pressed', 'true' );
							$( this ).attr( 'aria-label', 'Play video' );
						} else {
							player.play();
							$( this ).removeClass( 'paused' );
							$( this ).attr( 'aria-pressed', 'false' );
							$( this ).attr( 'aria-label', 'Pause video' );
						}
					} );
			} );
		},
		_initPrograms() {
			if ( 0 < $( '.programs-component' ).length ) {
				ReactDOM.render(
					<Programs />,
					$( '.programs-component' )[ 0 ]
				);
			}
		},
		_initNews() {
			if ( 0 < $( '.news-component' ).length ) {
				ReactDOM.render( <News />, $( '.news-component' )[ 0 ] );
			}
		},
		_initEvents() {
			if ( 0 < $( '.events-component' ).length ) {
				ReactDOM.render( <Events />, $( '.events-component' )[ 0 ] );
			}
		},
		_initNewsCarousel() {
			$( '.northland-carousel:not(.component--success-stories,.component--three-image-cta) .slider' ).slick( {
				slidesToShow: 4,
				slidesToScroll: 4,
				speed: 1600,
				rows: 0,
				prevArrow:
					'<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 18"><title>Previous</title><defs></defs><g><rect class="cls-1" x="-1" y="4" width="12" height="2" transform="translate(-2.07 5) rotate(-45)"/><rect class="cls-1" x="4" y="7" width="2" height="12" transform="translate(-7.73 7.34) rotate(-45)"/><rect class="cls-1" x="2" y="8" width="34" height="2"/></g></svg></button>',
				nextArrow:
					'<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 18"><title>Next</title><defs></defs><g><rect class="cls-1" x="-1" y="4" width="12" height="2" transform="translate(-2.07 5) rotate(-45)"/><rect class="cls-1" x="4" y="7" width="2" height="12" transform="translate(-7.73 7.34) rotate(-45)"/><rect class="cls-1" x="2" y="8" width="34" height="2"/></g></svg></button>',
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
							speed: 1200
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							speed: 800
						},
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							speed: 400
						},
					},
				],
			} );

			$( '.component--success-stories .slider, .component--three-image-cta .slider' ).slick( {
				slidesToShow: 3,
				slidesToScroll: 3,
				speed: 1200,
				rows: 0,
				prevArrow:
					'<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 18"><title>Previous</title><defs></defs><g><rect class="cls-1" x="-1" y="4" width="12" height="2" transform="translate(-2.07 5) rotate(-45)"/><rect class="cls-1" x="4" y="7" width="2" height="12" transform="translate(-7.73 7.34) rotate(-45)"/><rect class="cls-1" x="2" y="8" width="34" height="2"/></g></svg></button>',
				nextArrow:
					'<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 18"><title>Next</title><defs></defs><g><rect class="cls-1" x="-1" y="4" width="12" height="2" transform="translate(-2.07 5) rotate(-45)"/><rect class="cls-1" x="4" y="7" width="2" height="12" transform="translate(-7.73 7.34) rotate(-45)"/><rect class="cls-1" x="2" y="8" width="34" height="2"/></g></svg></button>',
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
							speed: 1200
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							speed: 800
						},
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							speed: 400
						},
					},
				],
			} );
		},
		_initProgressBar() {
			const $slider = $( '.slider' );
			const $progressBar = $( '.progress' );
			const $progressBarLabel = $( '.slider__label' );
			$progressBarLabel.text( '0% completed' );

			$slider.on(
				'beforeChange',
				( event, slick, currentSlide, nextSlide ) => {
					const calc = ( nextSlide / ( slick.slideCount - 1 ) ) * 100;

					$(event.currentTarget).parent().find( '.progress' )
						.css( 'background-size', calc + '% 100%' )
						.attr( 'aria-valuenow', calc );

					$(event.currentTarget).parent().find( '.progress .slider__label' ).text( Math.round(calc) + '% completed' );
				}
			);

			// $slider.slick({
			// 	slidesToShow: 4,
			// 	slidesToScroll: 1,
			// 	speed: 400
			// });
		},
		_initFloatLinks() {
			$(window).on("scroll", function () {
				if ($(this).scrollTop() > 76) {
					$(".nav-float").fadeIn(200);
				} else {
					$(".nav-float").fadeOut(50);
				}

				if ($(this).scrollTop() > 800) {
					if(window.innerHeight > 250) {
						$(".utility-float").fadeIn(200);
					}
				} else {
					$(".utility-float").fadeOut(200);
				}
			});

			$(window).on("resize", function () {
				if(window.innerHeight < 250) {
					$(".utility-float").hide();
				} else {
					if ($(this).scrollTop() > 800) {
						$(".utility-float").fadeIn(200);
					}
				}
			});

			$('.top-link').click((e) => {
				e.preventDefault();
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			});

			$('.copy-float').click((e) => {
				window.navigator.clipboard.writeText(window.location.href);
			});
		},
		_initCollapseMobile() {
			if ( $(window).width() < 992 ) {
				$('.column-filter').removeClass('show').addClass('collapse');
			}

			if ( $(window).width() >= 992 ) {
				$('.column-filter').removeClass('collapse').addClass('show');
			}

			$( window ).resize( function () {
				if ( $(window).width() < 992 ) {
					$('.column-filter').removeClass('show').addClass('collapse');
				}

				if ( $(window).width() >= 992 ) {
					$('.column-filter').removeClass('collapse').addClass('show');
				}
			});
		},
		_initFormControls() {
			$( '.direcory-filter-close' ).on( 'click', function (e) {
				e.preventDefault();
				const filter = $(e.currentTarget).data('filter');

				// Clear current department.
				// if ('search_last_name' === filter) {
				// 	$('input[id^="letter"]').prop( "checked", false );
				// }
				// $(`#select-${filter}`).val('');

				const queryString = window.location.search;
				const urlParams = new URLSearchParams(queryString);

				// Remove blanks.
				if (urlParams.has('campus')) {
					if ('' === urlParams.get('campus')) {
						urlParams.delete('campus');
					}
				}
				if (urlParams.has('department')) {
					if ('' === urlParams.get('department')) {
						urlParams.delete('department');
					}
				}
				// if (urlParams.has('search_last_name')) {
				// 	if ('' === urlParams.get('search_last_name')) {
				// 		urlParams.delete('search_last_name');
				// 	}
				// }

				// Remove clicked item.
				if (urlParams.has(filter)) {
					urlParams.delete(filter);
				}

				// Update the Uri.
				const uri = window.location.href.toString();
				if ( uri.indexOf( '?' ) > 0 ) {
					const cleanUri = uri.substring( 0, uri.indexOf( '?' ) );
					let currentUri = cleanUri;
					if ('' !== urlParams.toString()) {
						currentUri = cleanUri + '?' + urlParams.toString();
					}

					window.history.replaceState( {}, document.title, currentUri );
					location.reload();
				}
			} );

			$( '.directory-filter' ).on( 'change', function () {
				$( '#form-directory' ).submit();
			} );

			// if ( $( window ).width() < 992 ) {
			// 	$( '#select-department, #select-campus, #select-last-name' ).off( 'change' );
			// }
		},
		_initPrint() {
			$('.btn-print').click( e => {
				window.print();
			});
		},
		_initPopovers() {
			const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
			const popoverList = popoverTriggerList.map((popoverTriggerEl) => {
				return new Popover(popoverTriggerEl)
			});
		},
		_initClickableRow() {
			$('.clickable-row').mouseenter( function() {
				$(this).addClass('hover');
			});

			$('.clickable-row').mouseleave( function() {
				$(this).removeClass('hover');
			});

			$('.clickable-row').click( function() {
				window.location = $(this).data('href');
			});
		},
		_initCompare() {
			if ( $('.compare-program-wrapper').length > 0) {
				if(window.location.search) {
					let anchor = $( '#compare-results' );
					$('html,body').animate({scrollTop: anchor.offset().top},'slow');
				}

				$('.compare-pill .pill-close').click( function() {
					console.log('click!');
					let removeProgram = $(this).data('key');

					// console.log(removeProgram);

					let queryString = window.location.search;

					queryString = queryString.replace('prog[]=' + removeProgram, '');
					queryString = queryString.replace('prog%5B%5D=' + removeProgram, '');
					queryString = queryString.replace('prog%5b%5d=' + removeProgram, '');
					queryString = queryString.replace('?&', '?');

					// console.log(queryString);

					window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname + queryString;
				});
			}
		},
		_initClassSchedules() {
			$.fn.select2.defaults.set('amdLanguageBase', 'select2/i18n/');
			$('.select2').select2();
			// $(window).on('resize', function() {
			// 	$('.select2').select2();
			// });

			$('.btn-clear').click(function() {
				setTimeout(function() {
					$('#f-semester').val('');
					$('#f-campus').val('');
					$('#f-subject').val('');
					$('#f-time-compare').val('');
					$('#f-start-time').val('');
					$('#f-days').val('');
					$('.select2').select2();
				}, 100);
			});
		}
	};

	NorthlandScripts.init();
} );
